import { render, staticRenderFns } from "./PrintfulConfigurator.vue?vue&type=template&id=07826545&scoped=true"
import script from "./PrintfulConfigurator.vue?vue&type=script&lang=ts&setup=true"
export * from "./PrintfulConfigurator.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./PrintfulConfigurator.vue?vue&type=style&index=0&id=07826545&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07826545",
  null
  
)

export default component.exports